jQuery(document).ready(function ($) {
    const $lightbox = $('#bide-club-lightbox');

    if (!$lightbox.length) return;

    function open_lightbox() {
        $lightbox.addClass('is-open').attr('aria-hidden', false);
        $('body').addClass('bide-club-lightbox-open');
    }

    function close_lightbox() {
        $lightbox.removeClass('is-open').attr('aria-hidden', true);
        $('body').removeClass('bide-club-lightbox-open');
    }

    $(document).on('click', '.bide-club-popup', function (event) {
        event.preventDefault();
        open_lightbox();
    });

    $(document).on('click', '.js-bide-club-lightbox-close', function (event) {
        event.preventDefault();
        close_lightbox();
    });

    $(document).on('keydown', function (event) {
        if (event.key === 'Escape' && $lightbox.hasClass('is-open')) {
            close_lightbox();
        }
    });
});
